export default {
  apiKey: "AIzaSyAhMiByFo2djSEvOB7mqaj8n_zYn004w0w",
  projectId: "interfaceengineersite",
  appId: "1:449388258929:web:328d40789cb7670b449dd0",
  measurementId: "G-38B5EMGJQW",
};
